export default __webpack_public_path__ + "56e84af43525933435dc5f7740a3466f.png";